<template>
	<div class="data-ingedit">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/datacenter/dclist',params: {page: $route.query.page} }">食材</el-breadcrumb-item>
			<el-breadcrumb-item>编辑基本信息</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row style="margin-top:15px">
			<el-col style="width:200px;">
				<div class="photo">
					<el-upload
						class="avatar-uploader"
						style="border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
		height: 148px;"
						:action="uploadUrl"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<el-image
							v-if="form.ingredientsImage"
							style="width: 200px; height: 150px;"
							:src="form.ingredientsImageUrl"
							fit="cover"></el-image>
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="test" v-if="form.ingredientsImage">
							<div style="width:100px;height:148px;background: rgb(225, 225, 225);line-height:148px;float: left;">
								<svg-icon
								icon-class="upload"
								style="width:2em;height:2em;"
								></svg-icon>
							</div>
							<div style="width:100px;height:148px;background: rgb(250, 250, 250);line-height:148px;float: right" @click.stop="delImage($event)">
								<svg-icon
								icon-class="del"
								style="width:2em;height:2em;"
								></svg-icon>
							</div>
						</div>
					</el-upload>
				</div>
			</el-col>
			<el-col
			 :span="10"
			 style="padding-left:30px"
			>
				<el-form
				 ref="form"
				 :model="form"
				 :rules="fRule"
				 label-position="left"
				 label-width="94px"
				>
					<el-form-item prop="ingredientsName" label="食材名称：">
						<el-input v-model="form.ingredientsName"></el-input>
					</el-form-item>
					<el-form-item label="食材编码：">
						<el-input v-model="form.ingredientsCode" placeholder="多个请用英文逗号','分开"></el-input>
					</el-form-item>
					<el-form-item label="别   名：">
						<el-input v-model="form.aliasName" placeholder="多个请用英文逗号','分开"></el-input>
					</el-form-item>
					<el-form-item  prop="commonName" label="常用名：">
						<el-input v-model="form.commonName"></el-input>
					</el-form-item>
					<el-form-item  prop="jianpinName" label="首字符：">
						<el-input v-model="form.jianpinName"></el-input>
					</el-form-item>
					<el-form-item  prop="bigCateId" label="大类：">
						<el-select v-model="form.bigCateId" placeholder="请选择大类"  style="width:100%" @change="(val)=>getCateName(val,'big')">
							<el-option
								v-for="item in bigCateList"
								:key="item.cateName"
								:label="item.cateName"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item  prop="smallCateId" label="小类：">
						<el-select v-model="form.smallCateId" placeholder="请选择小类" style="width:100%" @change="(val)=>getCateName(val,'small')">
							<el-option
								v-for="item in smallCateList"
								:key="item.cateName"
								:label="item.cateName"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label-width="1px">
						<div style="font-size:12px;text-align:left;">营养素</div>
						<div style="height: 1px;background: #cccccc;margin-bottom: 10px;"></div>
					</el-form-item>
					<el-form-item label="可食部："  prop="eatPart" >
						<el-input v-model="form.eatPart">
							 <template slot="append">%</template>
						</el-input>
					</el-form-item>
					<el-form-item label="热量：" prop="energyKc" >
						<el-input v-model="form.energyKc">
							<template slot="append">千卡</template>
						</el-input>
					</el-form-item>
					<el-form-item label="碳水化合物：" prop="carbohydrate" >
						<el-input v-model="form.carbohydrate">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="蛋白质：" prop="protein" >
						<el-input v-model="form.protein">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="脂肪：" prop="fat" >
						<el-input v-model="form.fat">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="钙：" prop="autunite" >
						<el-input v-model="form.autunite">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="铁：" prop="iron" >
						<el-input v-model="form.iron">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="锌：" prop="zicn" >
						<el-input v-model="form.zicn">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="维生素A：" prop="va">
						<el-input v-model="form.va">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="维生素B1：" prop="vb1" >
						<el-input v-model="form.vb1">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="维生素B2：" prop="vb2" >
						<el-input v-model="form.vb2">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="维生素C：" prop="vc" >
						<el-input v-model="form.vc">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label-width="1px">
						<div style="height: 1px;background: #cccccc;margin-top: 10px;margin-bottom: 10px;"></div>
					</el-form-item>
					<el-form-item label="膳食纤维：" prop="df" >
						<el-input v-model="form.df">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="能量：" prop="energyKj" >
						<el-input v-model="form.energyKj">
							<template slot="append">千焦</template>
						</el-input>
					</el-form-item>
					<el-form-item label="水分：" prop="moisture" >
						<el-input v-model="form.moisture">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="胆固醇：" prop="cholesterol" >
						<el-input v-model="form.cholesterol">
							<template slot="append">毫克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="灰分：" prop="ashContent" >
						<el-input v-model="form.ashContent">
							<template slot="append">克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="胡萝卜素：" prop="carotene" >
						<el-input v-model="form.carotene">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="视黄醇：" prop="retinol" >
						<el-input v-model="form.retinol">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="烟酸：" prop="vpp" >
						<el-input v-model="form.vpp">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="维生素E：" prop="ve" >
						<el-input v-model="form.ve">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="磷：" prop="phosphorus" >
						<el-input v-model="form.phosphorus">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="钾：" prop="kalium" >
						<el-input v-model="form.kalium">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="钠：" prop="na" >
						<el-input v-model="form.na">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="镁：" prop="magnesium" >
						<el-input v-model="form.magnesium">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="硒：" prop="selenium" >
						<el-input v-model="form.selenium">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="铜：" prop="copper" >
						<el-input v-model="form.copper">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="锰：" prop="mineral" >
						<el-input v-model="form.mineral">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
					<el-form-item label="备注" prop="originPlace" >
						<el-input v-model="form.originPlace">
							<template slot="append">微克</template>
						</el-input>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row style="position: fixed;bottom:3px;padding-left:35%">
			<el-button type="primary" @click="onSubmit">保存</el-button>
    	<el-button @click="goBack()">取消</el-button>
		</el-row>
	</div>
</template>

<script>
import { queryIngredientDetail,queryBigCate,querySmallCate,save,update,getUploadUrl } from '@/api/catering/ingredient'
export default {
  name: "IngreditentInfo",
  data() {
    return {
      form: {
				id: null,
				ingredientsImage: null,
				ingredientsImageUrl: null,
        ingredientsName: null,
				ingredientsCode: null,
				commonName: null,
				aliasName: null,
				bigCateId: null,
				bigCateName: null,
				smallCateId: null,
				smallCateName: null,
				jianpinName: null,
				eatPart: null,
				energyKc: null,
				carbohydrate: null,
				protein: null,
				fat: null,
				autunite: null,
				iron: null,
				zicn: null,
				va: null,
				vb1: null,
				vb2: null,
				vc: null,
				df: null,
				energyKj: null,
				moisture: null,
				cholesterol: null,
				ashContent: null,
				carotene: null,
				retinol: null,
				vpp: null,
				ve: null,
				phosphorus: null,
				kalium: null,
				na: null,
				magnesium: null,
				selenium: null,
				copper: null,
				mineral: null,
				originPlace: null
			},
			fRule:{
				name: [{required: true, trigger: 'blur',message: "请输入名称"}],
				ingredientsName: [{required: true, trigger: 'blur',message: "请输入名称"}],
				commonName: [{required: true, trigger: 'blur',message: "请输入名称"}],
				aliasName: [{required: true, trigger: 'blur',message: "请输入名称"}],
				bigCateId: [{required: true, trigger: 'blur',message: "请输入名称"}],
				smallCateId: [{required: true, trigger: 'blur',message: "请输入名称"}],
				eatPart: [{required: true, trigger: 'blur',message: "请输入名称"}],
				energyKc: [{required: true, trigger: 'blur',message: "请输入名称"}],
				carbohydrate: [{required: true, trigger: 'blur',message: "请输入名称"}],
				protein: [{required: true, trigger: 'blur',message: "请输入名称"}],
				fat: [{required: true, trigger: 'blur',message: "请输入名称"}],
				autunite: [{required: true, trigger: 'blur',message: "请输入名称"}],
				iron: [{required: true, trigger: 'blur',message: "请输入名称"}],
				zicn: [{required: true, trigger: 'blur',message: "请输入名称"}],
				va: [{required: true, trigger: 'blur',message: "请输入名称"}],
				vb1: [{required: true, trigger: 'blur',message: "请输入名称"}],
				vb2: [{required: true, trigger: 'blur',message: "请输入名称"}],
				vc: [{required: true, trigger: 'blur',message: "请输入名称"}],
				df: [{required: true, trigger: 'blur',message: "请输入名称"}],
				energyKj: [{required: true, trigger: 'blur',message: "请输入名称"}],
				moisture: [{required: true, trigger: 'blur',message: "请输入名称"}],
				cholesterol: [{required: true, trigger: 'blur',message: "请输入名称"}],
				ashContent: [{required: true, trigger: 'blur',message: "请输入名称"}],
				carotene: [{required: true, trigger: 'blur',message: "请输入名称"}],
				retinol: [{required: true, trigger: 'blur',message: "请输入名称"}],
				vpp: [{required: true, trigger: 'blur',message: "请输入名称"}],
				ve: [{required: true, trigger: 'blur',message: "请输入名称"}],
				phosphorus: [{required: true, trigger: 'blur',message: "请输入名称"}],
				kalium: [{required: true, trigger: 'blur',message: "请输入名称"}],
				na: [{required: true, trigger: 'blur',message: "请输入名称"}],
				magnesium: [{required: true, trigger: 'blur',message: "请输入名称"}],
				selenium: [{required: true, trigger: 'blur',message: "请输入名称"}],
				copper: [{required: true, trigger: 'blur',message: "请输入名称"}],
				mineral: [{required: true, trigger: 'blur',message: "请输入名称"}],
				originPlace: [{required: true, trigger: 'blur',message: "请输入名称"}],
			},
			bigCateList: [],
			smallCateList: [],
			uploadUrl: null
    };
  },
	created() {
		this.getUploadUrl();
		this.queryIngredientDetail(this.$route.query.uid);
	},
  methods: {
		getUploadUrl() {
			this.uploadUrl = getUploadUrl();
		},
		handleAvatarSuccess(res, file) {
        this.form.ingredientsImageUrl = URL.createObjectURL(file.raw);
				this.form.ingredientsImage = res.data;
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg';
			const isPng = file.type === 'image/png';
			const isLt2M = file.size / 1024 / 1024 < 0.5;

			if (!isJPG && !isPng) {
				this.$message.error('上传食材图片只能是 JPG或PNG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传食材图片大小不能超过 500KB!');
			}
			return (isPng || isJPG) && isLt2M;
		},
		delImage(dd) {
			this.form.ingredientsImage = null;
			this.form.ingredientsImageUrl = null;
		},
		queryIngredientDetail(id) {
			if(id) {
				queryIngredientDetail(id).then(response=>{
					this.form = response.data;
          this.queryIngredientBigCateList();
				})
			} else {
        this.queryIngredientBigCateList();
      }
		},
		queryIngredientBigCateList() {
			queryBigCate().then(response=>{
				this.bigCateList = response.data;
        if(this.form.bigCateId) {
          let tmpSmallId = this.form.smallCateId;
          let tmpSmallName = this.form.smallCateName;
          this.getCateName(this.form.bigCateId,'big');
          this.form.smallCateId = tmpSmallId;
				  this.form.smallCateName = tmpSmallId;
        }
			})
		},
		getCateName(value,type) {
			if(type == 'big') {
				this.form.smallCateId = null;
				this.form.smallCateName = null;
				let techObj = this.bigCateList.filter(item=>{
					return item.id == value;
				})
				this.form.bigCateName = techObj[0].cateName;
				querySmallCate(value).then(response=>{
					this.smallCateList = response.data;
				})
			} else {
				let smallObj = this.smallCateList.filter(item=>{
					return item.id == value;
				})
				this.form.smallCateName = smallObj[0].cateName;
			}
		},
		goBack() {
			this.$router.push({name:'datalist',path: '/datacenter/dclist',params: {page: this.$route.query.page}});
		},
    onSubmit() {
			this.$refs['form'].validate(valid => {
        if (valid) {
					if(this.form.id) {
						update(this.form).then(response=>{
							this.$message.success('食材更新成功');
							this.goBack();
					})
					} else {
						save(this.form).then(response=>{
						this.$message.success('食材保存成功');
						this.$router.replace({path: '/datacenter/dclist'});
					})
					}
				}
			})
    }
  }
};
</script>

<style scoped>
.data-ingedit {
  margin-top: 15px;
	margin-left: 15px;
	padding-bottom: 30px;
	position: relative;
}
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
	.photo {
		position:relative
	}
	.photo:hover .test{
		display: block;
	}
  .test {
		position: absolute;
    width: 200px;
    top: 0;
    height: 150px;
    display: none;
    background-color: rgba(0,0,0,0.5);
		opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/ingredient/edit.vue